// built-ins
import { useDispatch, useSelector } from 'react-redux';

// types
import type { Dispatch } from '@reduxjs/toolkit';
import type { TypedUseSelectorHook } from 'react-redux';
import type { GlobalStore } from './index';
import type { RootActionType } from './actions';

export type DispatchType = Dispatch<RootActionType | any>;
export type SelectorType = TypedUseSelectorHook<GlobalStore>;

export const useAppDispatch = () => useDispatch<DispatchType>();
export const useAppSelector = useSelector as SelectorType;
